<template>
  <v-app>
    <v-app-bar
        app
        :color="appColor"
        dark
        class="d-print-none"
    >
      <div class="d-flex align-center">
        <!--<v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />-->
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span style="font-weight: bold;font-size: 30px" class="d-none d-md-inline">{{ appHeaderName }}</span>
      </div>

      <v-spacer></v-spacer>
      <span style="font-weight: bold;font-size: 30px" class="d-inline d-md-none">{{ appHeaderName }}</span>
      <span
          style="font-weight: bold;font-size: 30px;cursor: pointer;color: #ff6d81;border: 1px salmon solid;border-radius: 7px"
          @click="DownloadTutorial()"
          class="d-none d-md-inline mr-4">QR Line กลุ่ม/คู่มือการใช้งาน</span>
      <span style="font-weight: bold;font-size: 30px;cursor: pointer" @click="dialog = true"
            class="d-none d-md-inline">ออกจากระบบ</span>
    </v-app-bar>

    <v-content>

      <v-container
          class="mx-auto overflow-hidden"
      >

        <v-navigation-drawer
            v-model="drawer"
            :color="appColor"
            :expand-on-hover="expandOnHover"
            :mini-variant="miniVariant"
            fixed
            bottom
            temporary
            dark
            class="d-print-none"
        >
          <v-list
              dense
              nav
              class="py-0"
          >
            <v-list-item two-line :class="miniVariant && 'px-0'">
              <v-list-item-avatar>
                <img :src="mednet">
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title><span style="font-size: 16px"
                                         v-if="MeData.length > 0">{{ MeData[0].full_Name }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span style="font-size: 16px"
                        v-if="MeData.length > 0">{{ MeData[0].pos_name }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item
                v-for="(item, idx) in items"
                :key="idx"
                link
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <router-link :to="item.page">
                    <span style="color: white;font-size: 16px">{{ item.title }}
                    </span>
                </router-link>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-subheader class="mt-4">
              <span style="font-weight: bold;color: burlywood">เมนูสำหรับผู้ดูแล</span>
            </v-subheader>
            <v-subheader class="mt-4">
              <span style="font-weight: bold;color: blanchedalmond">ประชุม</span>
            </v-subheader>
            <template
                v-for="(item) in MeetMenu"
                link
            >
              <v-list-item
                  v-if="item.permiss"
                  :key="item.id"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <router-link :to="item.page">
                    <span style="color: white;font-size: 16px">{{ item.title }}
                    </span>
                  </router-link>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-divider></v-divider>
            <v-subheader class="mt-4">
              <span style="font-weight: bold;color: blanchedalmond">โครงการ / อบรม / เดินทางไปฏิบัติราชการ</span>
            </v-subheader>
            <v-list-item v-if="ProjectMenu.filter(item => item.permiss).length > 0">
              <v-btn class="ma-2 pa-1" color="#1976d2" @click="ChooseProcess('1', false)">โครงการ</v-btn>
              <v-btn class="ma-2 pa-1" color="#004D40" @click="ChooseProcess('2', false)">อบรม / เดินทาง</v-btn>
            </v-list-item>
            <template v-if="(TypeProject == null || TypeProject == '1')">
              <template
                  v-for="(item) in ProjectMenu"
                  link
              >
                <v-list-item
                    v-if="item.permiss"
                    :key="item.id"
                >
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <router-link :to="item.page">
                      <template v-if="item.id == 1000">
                        <span style="color: white;font-size: 16px">{{
                            ((TypeProject == null || TypeProject == '1') ? item.title : 'พิจารณา อบรม/เดินทางไปปฏิบัติงาน')
                          }}</span>
                      </template>
                      <template v-else>
                        <span style="color: white;font-size: 16px">{{ item.title }}</span>
                      </template>
                    </router-link>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>
            <template v-else>
              <template
                  v-for="(item) in ProjectMenu.filter(item => item.id != 7000 && item.id != 10000)"
                  link
              >
                <v-list-item
                    v-if="item.permiss"
                    :key="item.id"
                >
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <router-link :to="item.page">
                      <template v-if="item.id == 1000">
                        <span style="color: white;font-size: 16px">พิจารณา อบรม/เดินทางไปปฏิบัติงาน</span>
                      </template>
                      <template v-else-if="item.id == 9996">
                        <span style="color: white;font-size: 16px">พิจารณา เดินทางปฏิบัติงาน (ผู้บริหาร)</span>
                      </template>
                      <template v-else-if="item.id == 9000">
                        <span style="color: white;font-size: 16px">จัดอบรม/เดินทางไปปฏิบัติงาน</span>
                      </template>
                      <template v-else>
                        <span style="color: white;font-size: 16px">{{ item.title }}</span>
                      </template>
                    </router-link>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>
            <v-divider></v-divider>
            <v-subheader class="mt-4">
              <span style="font-weight: bold;color: blanchedalmond">รายงานสรุปโครงการ (ภาควิชา/หน่วยงาน)</span>
            </v-subheader>
            <v-divider></v-divider>
            <template v-for="(item) in ReportProjectByDepartment" link>
              <v-list-item
                  v-if="item.permiss"
                  :key="item.id"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <router-link :to="item.page">
                    <span style="color: white;font-size: 16px">{{ item.title }}
                    </span>
                  </router-link>
                </v-list-item-content>
              </v-list-item> 
            </template>
            <v-divider></v-divider>
            <v-subheader class="mt-4">
              <span style="font-weight: bold;color: blanchedalmond">รายงานสรุปโครงการ (ผู้มีอำนาจอนุมัติ)</span>
            </v-subheader>
            <v-divider></v-divider>
            <template v-for="(item) in ReportProject" link>
              <v-list-item
                  v-if="item.permiss"
                  :key="item.id"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <router-link :to="item.page">
                    <span style="color: white;font-size: 16px">{{ item.title }}
                    </span>
                  </router-link>
                </v-list-item-content>
              </v-list-item> 
            </template>
            <v-divider></v-divider>
            <v-subheader class="mt-4">
              <span style="font-weight: bold;color: blanchedalmond">แต่งตั้งคณะกรรมการ</span>
            </v-subheader>
            <template
                v-for="(item) in AppointmentMenu"
                link
            >
              <v-list-item
                  v-if="item.permiss"
                  :key="item.id"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <router-link :to="item.page">
                    <span style="color: white;font-size: 16px">{{ item.title }}
                    </span>
                  </router-link>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-divider></v-divider>
            <v-subheader class="mt-4">
              <span style="font-weight: bold;color: blanchedalmond">บุคคล</span>
            </v-subheader>
            <template
                v-for="(item) in PersonMenu"
                link
            >
              <v-list-item
                  v-if="item.permiss"
                  :key="item.id"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <router-link :to="item.page">
                    <span style="color: white;font-size: 16px">{{ item.title }}
                    </span>
                  </router-link>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-divider></v-divider>
            <v-subheader class="mt-4">
              <span style="font-weight: bold;color: blanchedalmond">ตั้งค่า</span>
            </v-subheader>
            <template
                v-for="(item) in SettingMenu"
                link
            >
              <v-list-item
                  v-if="item.permiss"
                  :key="item.id"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <router-link :to="item.page">
                    <span style="color: white;font-size: 16px">{{ item.title }}
                    </span>
                  </router-link>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-divider></v-divider>
            <v-subheader class="mt-4">
              <span style="font-weight: bold;color: blanchedalmond">อื่นๆ</span>
            </v-subheader>
            <template
                v-for="(item) in OtherMenu"
                link
            >
              <v-list-item
                  v-if="item.permiss"
                  :key="item.id"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <router-link :to="item.page">
                    <span style="color: white;font-size: 16px">{{ item.title }}
                    </span>
                  </router-link>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-navigation-drawer>
        <router-view></router-view>
      </v-container>
    </v-content>

    <Footer></Footer>
    <template>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>
          <v-card-text>คุณต้องการออกจากระบบใช่หรือไม่ ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false">ยกเลิก</v-btn>
            <v-btn color="green darken-1" text @click="LogOut">ตกลง</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogTutorial"
          max-width="1000"
          persistent>
        <v-card>
          <v-card-title class="font-weight-bold">
            <span>
              OR CODE กลุ่มไลน์, Flow, วิดิโอ, เอกสารคู่มือประกอบ
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-responsive>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('0')">
                Flow ระบบ
              </v-btn>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('1')">
                คู่มือ (เสนอแผนขออนุมัติงบประมาณประจำปี)
              </v-btn>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('2')">
                คู่มือ (จัดทำโครงการ หลังการอนุมัติแผน, จัดโครงการภายใน (ไม่เบิกงบคณะ))
              </v-btn>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('3')">
                คู่มือ (การสมัครเข้าร่วมโครงการ, เพิ่มรายชื่อผู้เข้าร่วม, ลงทะเบียนเข้าร่วม (หน้างาน), export
                รายชื่อผู้เข้าร่วม)
              </v-btn>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('4')">
                คู่มือ (การบันทึกข้อมูลตัวชี้วัดและแบบประเมินความพึงพอใจโครงการ)
              </v-btn>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('5')">
                คู่มือ (การตรวจสอบภาพรวมสรุปรายการค่าใช้จ่ายโครงการ)
              </v-btn>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('9')">
                คู่มือ (สร้างแบบสอบถาม)
              </v-btn>
              <v-divider></v-divider>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('6')">
                QR CODE กลุ่มไลน์ระบบ
              </v-btn>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('7')">
                วิดิโอสอนการใช้งาน การบันทึกข้อมูลโครงการ
              </v-btn>
              <v-btn color="primary" outlined class="font-weight-bold pa-6 ma-4" @click="OpenTutorial('8')">
                วิดิโอสอนการใช้งาน การเดินทางไปปฏิบัติงาน (ราชการ)
              </v-btn>
            </v-responsive>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark class="font-weight-bold" @click="dialogTutorial = false" color="red">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogChooseProcess"
          max-width="800">
        <v-card>
          <v-card-title class="font-weight-bold">
            <span v-if="Process == '1'" style="color: black">โครงการ : เลือกเมนูที่ต้องการทำรายการ</span>
            <span v-else style="color: black">อบรม/เดินทางไปปฏิบัติงาน : เลือกเมนูที่ต้องการทำรายการ</span>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <div align="center" class="mt-4 mb-4">
              <v-btn class="ma-2 pa-6" color="#1976d2" dark x-large @click="ChooseProcess('1', false)">โครงการ</v-btn>
              <v-btn class="ma-2 pa-6" color="#004D40" dark x-large @click="ChooseProcess('2', false)">อบรม / เดินทาง</v-btn>
            </div>
            <v-divider></v-divider>
            <template v-if="(Process == null || Process == '1')">
              <template
                  v-for="(item) in ProjectMenu"
                  link
              >
                <v-list-item
                    v-if="item.permiss"
                    :key="item.id"
                    style="background-color: white"
                    @click="dialogChooseProcess = false"
                >
                  <v-list-item-content>
                      <template v-if="item.id == 1000">
                        <v-btn text x-large style="color: black;font-size: 16px;font-weight: bold" @click="goToPage(item)">{{
                            ((Process == null || Process == '1') ? item.title : 'พิจารณา อบรม/เดินทางไปปฏิบัติงาน')
                          }}</v-btn>
                      </template>
                      <template v-else>
                        <v-btn text x-large style="color: black;font-size: 16px;font-weight: bold" @click="goToPage(item)">{{ item.title }}</v-btn>
                      </template>
                    <v-divider></v-divider>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>
            <template v-else>
              <template
                  v-for="(item) in ProjectMenu.filter(item => item.id != 7000 && item.id != 10000)"
                  link
              >
                <v-list-item
                    v-if="item.permiss"
                    :key="item.id"
                    @click="dialogChooseProcess = false"
                >
                  <v-list-item-content>
                      <template v-if="item.id == 1000">
                        <v-btn text x-large style="color: black;font-size: 16px;font-weight: bold" @click="goToPage(item)">พิจารณา อบรม/เดินทางไปปฏิบัติงาน</v-btn>
                      </template>
                      <template v-else-if="item.id == 9996">
                        <v-btn text x-large style="color: black;font-size: 16px;font-weight: bold" @click="goToPage(item)">พิจารณา เดินทางปฏิบัติงาน (ผู้บริหาร)</v-btn>
                      </template>
                      <template v-else-if="item.id == 9000">
                        <v-btn text x-large style="color: black;font-size: 16px;font-weight: bold" @click="goToPage(item)">จัดอบรม/เดินทางไปปฏิบัติงาน</v-btn>
                      </template>
                      <template v-else>
                        <v-btn text x-large style="color: black;font-size: 16px;font-weight: bold" @click="goToPage(item)">{{ item.title }}</v-btn>
                      </template>
                    <v-divider></v-divider>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark class="font-weight-bold" @click="dialogChooseProcess = false" color="red">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
        </v-dialog>
    </template>
  </v-app>


</template>

<script>
import Footer from './Footer'
import {mapActions, mapGetters} from "vuex";
import ConstData from './../const/Const'
import Const from "@/const/Const";
// import axios from "axios";

export default {
  name: 'Train',
  components: {
    Footer
  },
  created() {
    this.$root.$refs.Train = this;
  },
  data() {
    return {
      Process: null,
      dialogChooseProcess: false,
      dialogTutorial: false,
      CheckAdmin: false,
      dialog: false,
      drawer: true,
      items: [
        {title: 'โปรไฟล์', page: '/', icon: 'mdi-account'},
        {title: 'โครงการ', page: '/Project2', icon: 'mdi-feature-search-outline'},
        {title: 'ประชุม', page: '/JoinMeetingPerson', icon: 'mdi-human-male-male'},
      ],
      mednet: '',
      color: 'primary',
      colors: [
        'primary',
        'blue',
        'success',
        'red',
        'teal',
      ],
      right: true,
      miniVariant: false,
      expandOnHover: false,
      background: true,
      ProjectMenu: [
        {
          title: 'ขอเสนอแผนอนุมัติงบประมาณประจำปี',
          page: '/Propose_a_plan',
          icon: 'mdi-view-grid-outline',
          id: 10000,
          permiss: false
        },
        {
          title: 'พิจารณาเสนอแผนอนุมัติงบประมาณประจำปี',
          page: '/BudgetProject',
          icon: 'mdi-view-grid-outline',
          id: 9996,
          permiss: false
        },
        {
          title: 'จัดโครงการ (เบิกงบ, ไม่เบิกงบ)',
          page: '/ManageProject',
          icon: 'mdi-view-grid-outline',
          id: 9000,
          permiss: false
        },
        {
          title: 'พิจารณาโครงการ (ภายใน, ไม่เบิกงบ)',
          page: '/Project',
          icon: 'mdi-view-grid-outline',
          id: 1000,
          permiss: false
        },
        {title: 'เข้าร่วมโครงการ', page: '/JoinProject', icon: 'mdi-view-grid-outline', id: 7000, permiss: false},
      ],
      PersonMenu: [
        {
          title: 'จัดการข้อมูลบุคคล',
          page: '/ManagePerson',
          icon: 'mdi-account',
          id: 8000,
          permiss: false
        },
      ],
      ReportProjectByDepartment: [
        {
          title: 'รายงานสรุปค่าใช้จ่ายโครงการ (ภาควิชา/หน่วยงาน)',
          page: '/ReportProjectByDepartment',
          icon: 'mdi-file-document',
          id: 19001,
          permiss: false
        },
      ],
      ReportProject: [
        {
          title: 'รายงานสรุปค่าใช้จ่ายโครงการ (ผู้มีอำนาจอนุมัติ)',
          page: '/ReportProject',
          icon: 'mdi-file-document',
          id: 19000,
          permiss: false
        },
        {
          title: 'รายงานสรุปความพึงพอใจโครงการ (ผู้มีอำนาจอนุมัติ)',
          page: '/ReportSatisfaction',
          icon: 'mdi-file-document',
          id: 19002,
          permiss: false
        }
      ],
      AppointmentMenu: [
        {
          title: 'แต่งตั้งคณะกรรมการ',
          page: '/Appointment',
          icon: 'mdi-account',
          id: 13000,
          permiss: false
        },
      ],
      SettingMenu: [
        {
          title: 'ตั้งค่าข้อมูลบันทึกแผนประจำปี',
          page: '/SettingDateForPlan',
          icon: 'mdi-cog-outline',
          id: 14000,
          permiss: false
        },
        {
          title: 'ตั้งค่ารายละเอียดค่าใช้จ่าย',
          page: '/SettingExpenses',
          icon: 'mdi-cog-outline',
          id: 16000,
          permiss: false
        },
        {
          title: 'ตั้งค่าเงื่อนไขตำแหน่ง',
          page: '/PositionPerCourse',
          icon: 'mdi-cog-outline',
          id: 3000,
          permiss: false
        },
        {
          title: 'ตั้งค่างบวิชาการคงเหลือ',
          page: '/AcademicFundsRemaining',
          icon: 'mdi-cog-outline',
          id: 17000,
          permiss: false
        },
        {
          title: 'ตั้งค่าข้อมูลกิจกรรมเริ่มต้น',
          page: '/SettingTrainOfPersonal',
          icon: 'mdi-cog-outline',
          id: 18000,
          permiss: false
        },
        {title: 'จัดการข้อมูลหลักสูตร', page: '/ManageCourse', icon: 'mdi-cog-outline', id: 2000, permiss: false},
        {title: 'ตั้งค่า Competency', page: '/SettingCompetency', icon: 'mdi-cog-outline', id: 4000, permiss: false},
        {
          title: 'จัดการข้อมูลตำแหน่งบริหาร/หัวหน้าหน่วยงาน',
          page: '/SettingManagerial',
          icon: 'mdi-cog-outline',
          id: 5000,
          permiss: false
        },
      ],
      OtherMenu: [
        {title: 'รายงาน', page: '/Report', icon: 'mdi-information-variant', id: 6000, permiss: false},
        {title: 'งานนโยบายและแผน', page: '/Item_Code', icon: 'mdi-information-variant', id: 9997, permiss: false},
        {title: 'สิทธิ์การใช้งาน', page: '/Permission', icon: 'mdi-information-variant', id: 9999, permiss: false},
        {
          title: 'จัดการข้อมูลสิทธิ์การใช้งาน',
          page: '/SettingPermission',
          icon: 'mdi-information-variant',
          id: 9998,
          permiss: false
        },
      ],
      MeetMenu: [
        {title: 'จัดประชุม', page: '/Meeting', icon: 'mdi-human-queue', id: 11000, permiss: false},
        {
          title: 'ลงทะเบียนเข้าร่วมประชุม',
          page: '/ReggisterMeeting',
          icon: 'mdi-human-queue',
          id: 12000,
          permiss: false
        },
      ]
    }
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initStaffData: 'Staff/initStaffData',
      initAllStaffData: 'Staff/initAllStaffData',
      initDepartData: 'Depart/initDepartData',
      saveSessions: 'Staff/saveSessions',
      initPermissionData: 'Permission/initPermissionData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionData: 'Permission/getPermissionData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      initApproveProjectData: 'Project/initApproveProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      getPermissionDep: 'Permission/getPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initStatusProject: 'Project/initStatusProject',
      initTempStatusProject: 'Project/initTempStatusProject',
      initAllProjectRegister: 'Project/initAllProjectRegister',
      changeTypeProject: 'Project/changeTypeProject',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
    }),
    ToggleMenuClose: function () {
      window.console.log('ToggleMenu')
      // this.drawer = false;
    },
    OpenTutorial(param) {
      if (param == '0') {
        window.open(
            'https://medhr.medicine.psu.ac.th/HrTrain2/กระบวนการทำงานแผน.pdf',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else if (param == '1') {
        window.open(
            'https://medhr.medicine.psu.ac.th/HrTrain2/คู่มือเสนอแผนขออนุมัติงบประมาณประจำปี.pdf',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else if (param == '2') {
        window.open(
            'https://medhr.medicine.psu.ac.th/HrTrain2/คู่มือจัดทำโครงการ หลังการอนุมัติแผน.pdf',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else if (param == '3') {
        window.open(
            'https://medhr.medicine.psu.ac.th/HrTrain2/คู่มือเข้าร่วมโครงการ.pdf',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else if (param == '4') {
        window.open(
            'https://medhr.medicine.psu.ac.th/HrTrain2/การบันทึกข้อมูลตัวชี้วัดและแบบประเมินความพึงพอใจโครงการ.pdf',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else if (param == '5') {
        window.open(
            'https://medhr.medicine.psu.ac.th/HrTrain2/การตรวจสอบภาพรวมสรุปรายการค่าใช้จ่ายโครงการ.pdf',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else if (param == '6') {
        window.open(
            'https://medhr.medicine.psu.ac.th/HrTrain2/qr_line.jpg',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else if (param == '7') {
        window.open(
            'https://medhr.medicine.psu.ac.th/HrTrain2/trainVideo.html#/',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else if (param == '8') {
        window.open(
            'https://medhr.medicine.psu.ac.th/HrTrain2/trainVideo2.html#/',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else if (param == '9') {
        window.open(
            'https://medpsu-1.gitbook.io/medassess',
            '_blank' // <- This is what makes it open in a new window.
        );
      } else {
        this.$swal.fire({
          icon: 'warning',
          title: 'รออัพเดทข้อมูล !!'
        })
      }
    },
    DownloadTutorial() {
      this.dialogTutorial = true
      // this.$swal.fire({
      //   icon: 'warning',
      //   title: 'รออัพเดทข้อมูล !!'
      // })
    },
    ChooseProcess(Process, anotherPage) {
      this.Process = Process
      if (anotherPage) {
        this.$router.push('/')
        this.dialogChooseProcess = true
      } else {
        if (this.$route.path != '/Propose_a_plan' && this.$route.path != '/BudgetProject' && this.$route.path != '/Project' && this.$route.path != '/ManageProject' && this.$route.path != '/JoinProject') {
          this.changeTypeProject({
            type: Process
          })
          this.dialogChooseProcess = true
        } else {
          if (Process == '1') {
            this.changeTypeProject({
              type: '1'
            })
            this.changeColor({
              color: '#1976d2'
            })
            this.changeHeaderName({
              headerName: Const.defaultHeaderApp1
            })
          } else {
            this.changeTypeProject({
              type: '2'
            })
            this.changeColor({
              color: '#004D40'
            })
            this.changeHeaderName({
              headerName: Const.defaultHeaderApp2
            })
            if (this.$route.path == '/Propose_a_plan' || this.$route.path == '/JoinProject') {
              this.$router.push('/')
            }
          }
        }
      }

    },
    alertText() {
      alert('true')
    },
    LogOut() {
      document.cookie = 'access_token=; Max-Age=0'
      window.location.href = ConstData.ConnectionHost + '/SingleSign/';
      this.dialog = false
    },
    goToPage(param){
      this.$router.push(param.page)
      this.dialogChooseProcess = false
    }
  },
  computed: {
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      AllStaff: 'Staff/getAllStaff',
      AllPermission: 'Permission/getAllPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      PermissionAdmin: 'Permission/getPermission',
      ApproveProject: 'Project/getApproveProject',
      TypeProject: 'Project/getTypeProject',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  mounted() {
    this.saveSessions({
      session: ConstData.ConnectionHostHrTrain
    })
    this.initApproveProjectData()
    this.initDepartData()
    this.initStaffData()
    // this.initAllStaffData()
    this.initStatusProject()
    this.initTempStatusProject()
    this.initAllProjectRegister()
    this.initMeData().then(res => {
      if (res) {
        // this.mednet = ConstData.ConnectionMedNet + '/Personal/ShowPictNew.php?pid=' + this.MeData[0].perid
        /* this.initProjectDataForApprove({
          perid: this.MeData[0].perid
        }) */
        this.mednet = ConstData.ConnectionHost + '/ImageMED.php?pid=' + this.MeData[0].perid
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(res => {
          if (res) {
            this.getPermissionDep({
              perid: this.MeData[0].perid
            })
            if (this.PermissionAdmin.length > 0) {
              this.PermissionAdmin.map(Per_i => {
                switch (Per_i.permission_id) {
                  case '7000' :
                  case '9000' :
                  case '10000' :
                  case '1000' :
                    this.ProjectMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                    break;
                  case '2000' :
                  case '3000' :
                  case '4000' :
                  case '5000' :
                  case '16000' :
                  case '17000' :
                  case '18000' :
                  case '14000' :
                    this.SettingMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                    break
                  case '6000' :
                    this.OtherMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                    break
                  case '8000' :
                    this.PersonMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                    break
                  case '11000' :
                  case '12000' :
                    this.MeetMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                    break
                  case '13000' :
                    this.AppointmentMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                    break
                  case '19000' :
                    this.ReportProject.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                    break
                  case '19001' :
                    this.ReportProjectByDepartment.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                    break
                  case '19002' :
                    this.ReportProject.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                    break
                  default:
                    break;
                }
              })
              this.OtherMenu.filter(item => item.id == 9997)[0].permiss = true
              this.OtherMenu.filter(item => item.id == 9999)[0].permiss = true
            } else {
              this.getPermissionUserData({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  if (this.Permission.length > 0) {
                    this.Permission.map(Per_i => {
                      switch (Per_i.permission_id) {
                        case '7000' :
                        case '9000' :
                        case '10000' :
                        case '1000' :
                          this.ProjectMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                          break;
                        case '2000' :
                        case '3000' :
                        case '4000' :
                        case '5000' :
                        case '16000' :
                        case '17000' :
                        case '18000' :
                        case '14000' :
                          this.SettingMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                          break
                        case '6000' :
                          this.OtherMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                          break
                        case '8000' :
                          this.PersonMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                          break
                        case '11000' :
                        case '12000' :
                          this.MeetMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                          break
                        case '13000' :
                          this.AppointmentMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                          break
                        case '19000' :
                          this.ReportProject.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                          break
                        case '19001' :
                          this.ReportProjectByDepartment.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                          break
                        case '19002' :
                          this.ReportProject.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                          break
                        default:
                          break;
                      }
                    })
                  }
                }
              })
            }
            if (this.ApproveProject.length > 0) {
              if (this.ApproveProject.filter(Approve_i => Approve_i.perid == this.MeData[0].perid).length > 0) {
                this.ProjectMenu.filter(item => item.id == 9996)[0].permiss = true
                this.OtherMenu.filter(item => item.id == 9998)[0].permiss = true
              }
            }
          } else {
            if (this.ApproveProject.length > 0) {
              if (this.ApproveProject.filter(Approve_i => Approve_i.perid == this.MeData[0].perid).length > 0) {
                this.ProjectMenu.filter(item => item.id == 9996)[0].permiss = true
                this.OtherMenu.filter(item => item.id == 9998)[0].permiss = true
              }
            }
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                this.getPermissionDepUserData({
                  perid: this.MeData[0].perid
                })
                if (this.Permission.length > 0) {
                  this.Permission.map(Per_i => {
                    switch (Per_i.permission_id) {
                      case '7000' :
                      case '9000' :
                      case '10000' :
                      case '1000' :
                        this.ProjectMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                        break;
                      case '2000' :
                      case '3000' :
                      case '4000' :
                      case '5000' :
                      case '16000' :
                      case '17000' :
                      case '18000' :
                      case '14000' :
                        this.SettingMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                        break
                      case '6000' :
                        this.OtherMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                        break
                      case '8000' :
                        this.PersonMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                        break
                      case '11000' :
                      case '12000' :
                        this.MeetMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                        break
                      case '13000' :
                        this.AppointmentMenu.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                        break
                      case '19000' :
                        this.ReportProject.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                        break
                      case '19001' :
                        this.ReportProjectByDepartment.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                        break
                      case '19002' :
                        this.ReportProject.filter(item => item.id == parseInt(Per_i.permission_id))[0].permiss = true
                        break
                      default:
                        break;
                    }
                  })
                }
              }
            })
          }
        })
        // this.init()
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
};
</script>

<style>
/*@import url('https://fonts.googleapis.com/css?family=Prompt&display=swap');*/

* {
  font-family: 'Sarabun', sans-serif;
}

body {
  font-family: 'Sarabun', sans-serif;
}

@media print {
  .no-print {
    display: none;
  }

  .printm {
    display: block;
  }
}
</style>
